import { ProductionChart } from "./ProductionChart";

export default ProductionChart;
